// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconUserGroup = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M60.5353 40H44.637C43.6112 40 42.8953 38.9983 43.2212 38.0256C43.7272 36.5156 44 34.8309 44 33C44 24.8241 39 23.4142 39 17C39 11.4467 42.0637 8 47 8C51.9364 8 55 11.4467 55 17C55 20.6676 53.6572 23.4077 51.3277 24.8516C59.6573 26.722 60.6068 28.9464 61.9733 38.3054C62.13 39.3792 61.591 40 60.5353 40ZM36.3276 40.8516C38.6571 39.4077 40 36.6676 40 33C40 27.4467 36.9363 24 32 24C27.0637 24 24 27.4467 24 33C24 36.6676 25.3428 39.4077 27.6723 40.8516C19.3427 42.722 18.3932 44.9464 17.0267 54.3054C16.87 55.3792 17.409 56 18.4647 56H45.5352C46.591 56 47.13 55.3792 46.9732 54.3054C45.6068 44.9464 44.6573 42.722 36.3276 40.8516ZM20.7788 38.0256C20.2728 36.5156 20 34.8309 20 33C20 24.8241 25 23.4142 25 17C25 11.4467 21.9364 8 17 8C12.0637 8 9.00001 11.4467 9.00001 17C9.00001 20.6676 10.3428 23.4077 12.6723 24.8516C4.34272 26.722 3.3932 28.9464 2.02674 38.3054C1.87001 39.3792 2.40901 40 3.46473 40H19.363C20.3888 40 21.1047 38.9983 20.7788 38.0256Z" />
    </svg>
  );
};
